<template>
  <v-layout
    id="plannerTabNavigation"
    align-end
    justify-start
    :class="{'disable-tab' : disableTabs}"
  >
    <v-flex
      v-for="item in items"
      :key="item.value"
      shrink
      class="planner-tab hwayzTab-background"
      :class="{'planner-tab--active': getSelectedTab === item.value}"
      :style="{'width': `${100 / items.length}%`, 'color': getHeaderColor(item)}"
      @click="$emit('update:active', item.value)"
    >
      <v-icon
        v-if="item.icon"
        :color="getHeaderColor(item)"
        class="planner-tab-icon"
      >
        {{ item.icon }}
      </v-icon>
      <template v-else>
        <svg-icon
          :name="item.svgIcon"
          class="planner-tab-icon"
          :height="item.size"
          :width="item.size"
        />
      </template>
      <span class="planner-tab-label">{{ item.title }}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import colors from '../../../scss/_colors.scss'

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    disableTabs: {
      type: Boolean,
      default: false
    },
    active: {
      type: Number,
      default: 0
    },
    feedbackPage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('agent', ['selectedTab']),
    ...mapState('common', ['selectedFavoritesTab']),

    getSelectedTab() {
      return this.feedbackPage ? this.selectedFavoritesTab : this.selectedTab
    }
  },

  methods: {
    getHeaderColor(item) {
      return this.getSelectedTab === item.value
        ? colors.hwayzAgentHeader
        : colors.hwayzWhite
    }
  }
}
</script>

<style lang="sass" scoped>
.planner-tab
  border-radius: 0.9rem 0.9rem 0 0
  cursor: pointer
  text-align: center
  height: 5rem

.planner-tab:not(:last-child)
  margin-right: 1rem

.planner-tab--active
  background-color: $hwayzWhite
  -webkit-box-shadow: 0.2rem -0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  -moz-box-shadow: 0.2rem -0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  box-shadow: 0.2rem -0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)

.planner-tab-icon
  color: inherit
  font-size: $hwayzFont2rem
  margin-right: 1rem
  vertical-align: middle

.planner-tab-label
  line-height: 5rem

.disable-tab
  @extend %disabled-state
</style>
